import { BOUNDING_BOX_AVATAR_SIZE } from '~/components/BoundingBox/components/BoundingBoxAvatar';

export const BOUNDING_BOX_LAYER_Z_INDEX = 3;

export const BOUNDING_BOX_TEXT_WIDTH = 340;
export const BOUNDING_BOX_TEXT_MARGIN = 12;

export const BOUNDING_BOX_TEXT_FORM_WIDTH =
  BOUNDING_BOX_TEXT_WIDTH + BOUNDING_BOX_TEXT_MARGIN + BOUNDING_BOX_AVATAR_SIZE + 4;
